import type { TFunction } from 'i18next';
import type { AdminPasswordIssue } from '@harbormaster/shared';

const ISSUE_I18N_KEYS: Record<AdminPasswordIssue, string> = {
  TOO_SHORT: 'auth.passwordTooShort',
  TOO_LONG: 'auth.passwordTooLong',
  MISSING_LOWERCASE: 'auth.passwordNeedLowercase',
  MISSING_UPPERCASE: 'auth.passwordNeedUppercase',
  MISSING_DIGIT: 'auth.passwordNeedDigit',
  MISSING_SPECIAL: 'auth.passwordNeedSpecial',
};

export function tAdminPasswordIssue(t: TFunction, issue: AdminPasswordIssue): string {
  return t(ISSUE_I18N_KEYS[issue]);
}
